import React, { Component } from 'react'
import { Button, Form, Input, InputNumber, Upload, Icon, Switch, DatePicker, Select } from 'antd'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { message } from 'antd'
import config from '../../utils/config'
import InputMask from 'react-input-mask';
import { all, get, create } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
var IconAwesome = require('react-fontawesome');
const mexico_states = require('../../data/mexico_states')
const usa_states = require('../../data/usa_states')
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;

class EmployeeNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            imageUrl: '',
            file: {},
            loading: false,
            employee: {},
            hotels: [],
            states_options: []
        }

        if (localStorage.getItem('currentHotel')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.params.employeeId) {
            this.props.dispatch({type: 'app/showLoading'})

            get('Employee', this.props.params.employeeId, {include: 'hotel'}).then((resp) => {

                if (resp.type === 'hotel' && resp.hotel) {
                    setTimeout(function() {
                        resp.hotel = {key: resp.hotel.objectId, label: resp.hotel.name};
                        this.props.form.setFieldsValue({hotel: resp.hotel});
                    }.bind(this), 300);
                }

                if (resp.birthday)
                    resp.birthday = moment(new Date(resp.birthday.iso), 'YYYY/MM/DD');

                if (resp.alta_imss)
                    resp.alta_imss = moment(new Date(resp.alta_imss.iso), 'YYYY/MM/DD');

                if (resp.alta_employee)
                    resp.alta_employee = moment(new Date(resp.alta_employee.iso), 'YYYY/MM/DD');

                this.props.form.setFieldsValue(resp);
                this.setState({ employee: resp });

                this.props.dispatch({type: 'app/hideLoading'})
            })
        }

        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId

        if (this.props.app.user.type === 'recepcionista') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 50}).then((resp) => {
            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
            this.setState({
                hotels: resp.results
            });
        })
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Codifica la imagen al formato Base64
    */
    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }


    /**
    * Validación antes de subir la imagen
    */
    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 2MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }


    /**
    * Visualiza la imagen preview subida
    */
    handlePictureChange (info) {
        if (info.file.status === 'done') {
            this.getBase64(info.file.originFileObj, imageUrl => this.setState({ imageUrl }));
            this.setState({loading: false});
        }
    }


    /**
    * Validator: Checa el correcto formato del teléfono
    */
    checkPhone (rule, value, callback) {
        if (value && value.replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el empleado!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');

        } else {
            callback();
        }
    } 


    /**
    * Validator: Checa que el monto sea mayor a 0 solo del campo de sueldo diario
    */
    checkSalary (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');

        } else {

            // Elimina la leyenda de error y asigna el valor correcto
            if (this.props.form.getFieldValue('percent_pagadora'))
                this.props.form.setFields({ percent_pagadora: { value: this.props.form.getFieldValue('percent_pagadora'), errors: null, }});

            if (this.props.form.getFieldValue('percent_missing'))
                this.props.form.setFields({ percent_missing: { value: this.props.form.getFieldValue('percent_missing'), errors: null, }});

            if (this.props.form.getFieldValue('amount_pagadora'))
                this.props.form.setFields({ amount_pagadora: { value: this.props.form.getFieldValue('amount_pagadora'), errors: null, }});

            if (this.props.form.getFieldValue('amount_missing'))
                this.props.form.setFields({ amount_missing: { value: this.props.form.getFieldValue('amount_missing'), errors: null, }});


            // Recalcula los montos y porcentajes
            if (this.props.form.getFieldValue('percent_pagadora'))
                this.handlePercentPagadora(this.props.form.getFieldValue('percent_pagadora'));

            callback();
        }
    } 


    /**
    * Muestra los estados según el país elegido
    */
    handleCountry (value) {
        this.props.form.setFieldsValue({state: ''});

        if (value === 'México')
            this.setState({states_options: mexico_states.map(d => <Option key={d.name} label={d.name}>{d.name}</Option>)})
                              
        if (value === 'USA')
            this.setState({states_options: usa_states.map(d => <Option key={d.name} label={d.name}>{d.name}</Option>)})
    }


    /**
    * Asigna el nuevo monto según lo obtenido en el campo de porcentaje de la pagadora
    */
    handlePercentPagadora (value) {

        if (this.props.form.getFieldValue('salary')) {
            var salary;
            _.isNumber(this.props.form.getFieldValue('salary')) ? salary = this.props.form.getFieldValue('salary') : salary = Number(this.props.form.getFieldValue('salary').replace(/[^\d.-]/g, ''));
            var percent = value / 100;
            var total = '$' + parseFloat(salary * percent).toFixed(2);

            this.props.form.setFields({
                amount_pagadora: { value: total },
                amount_missing: { value: '$' + parseFloat(salary - total.replace(/[^\d.-]/g, '')).toFixed(2) },
                percent_missing: { value: 100 - value }
            });
        }
    }


    /**
    * Asigna el nuevo monto según lo obtenido en el campo de porcentaje de la pagadora
    */
    handlePercentMissing (value) {

        if (this.props.form.getFieldValue('salary')) {
            var salary;
            _.isNumber(this.props.form.getFieldValue('salary')) ? salary = this.props.form.getFieldValue('salary') : salary = Number(this.props.form.getFieldValue('salary').replace(/[^\d.-]/g, ''));
            var percent = value / 100;
            var total = '$' + parseFloat(salary * percent).toFixed(2);

            this.props.form.setFields({
                amount_missing: { value: total },
                amount_pagadora: { value: '$' + parseFloat(salary - total.replace(/[^\d.-]/g, '')).toFixed(2) },
                percent_pagadora: { value: 100 - value }
            });
        }
    }


    /**
    * Asigna el nuevo porcentaje según lo obtenido en el campo de monto de la pagadora
    */
    checkAmountPagadora (rule, value, callback) {

        if (!this.props.form.getFieldValue('salary')) {
            this.props.form.validateFields(['salary']);
            callback('Primero debe ingresar el sueldo diario');

        } else {
            var salary, amount;
            
            _.isNumber(this.props.form.getFieldValue('salary')) ? salary = this.props.form.getFieldValue('salary') : salary = Number(this.props.form.getFieldValue('salary').replace(/[^\d.-]/g, ''));
            _.isNumber(value) ? amount = value : amount = Number(value.replace(/[^\d.-]/g, ''));

            var total = Number(parseFloat((amount / salary) * 100).toFixed(2));

            if (amount > salary) {
                callback('El monto sobrepasa el sueldo diario');
            } else {
                this.props.form.setFields({ 
                    percent_pagadora: { value: total },
                    percent_missing: { value: 100 - total },
                    amount_missing: { value: '$' + parseFloat(salary - amount).toFixed(2) }
                });
                callback();
            }
        }
    }


    /**
    * Asigna el nuevo porcentaje según lo obtenido en el campo de monto de la pagadora
    */
    checkAmountMissing (rule, value, callback) {

        if (!this.props.form.getFieldValue('salary')) {
            this.props.form.validateFields(['salary']);
            callback('Primero debe ingresar el sueldo diario');

        } else {
            var salary, amount;

            _.isNumber(this.props.form.getFieldValue('salary')) ? salary = this.props.form.getFieldValue('salary') : salary = Number(this.props.form.getFieldValue('salary').replace(/[^\d.-]/g, ''));
            _.isNumber(value) ? amount = value : amount = Number(value.replace(/[^\d.-]/g, ''));

            var total = Number(parseFloat((amount / salary) * 100).toFixed(2));
            var percent_pagadora = Number(parseFloat(100 - total).toFixed(2));

            if (amount > salary) {
                callback('El monto sobrepasa el sueldo diario');
            } else {
                this.props.form.setFields({
                    percent_missing: { value: total },
                    percent_pagadora: { value: percent_pagadora },
                    amount_pagadora: { value: '$' + parseFloat(salary - amount).toFixed(2) }
                });
                callback();
            }
        }
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Validations
            if (values.phone)
                values.phone = values.phone.replace(/[^\d.]/g, '');

            if (this.state.file.uid)
                values.picture = this.state.file.uid + '.jpg';


            // Fechas
            if (values.birthday)
                values.birthday = {__type: 'Date', iso: new Date(values.birthday).toISOString()};

            if (values.alta_imss)
                values.alta_imss = {__type: 'Date', iso: new Date(values.alta_imss).toISOString()};

            if (values.alta_employee)
                values.alta_employee = {__type: 'Date', iso: new Date(values.alta_employee).toISOString()};


            // Montos
            if (values.salary)
                !_.isNumber(values.salary) ? values.salary = Number(values.salary.replace(/[^\d.-]/g, '')) : null;
            else
                values.salary = 0;

            if (values.bonus_sunday)
                !_.isNumber(values.bonus_sunday) ? values.bonus_sunday = Number(values.bonus_sunday.replace(/[^\d.-]/g, '')) : null;
            else
                values.bonus_sunday = 0;

            if (values.total_infonavit)
                !_.isNumber(values.total_infonavit) ? values.total_infonavit = Number(values.total_infonavit.replace(/[^\d.-]/g, '')) : null;
            else
                values.total_infonavit = 0;

            if (values.relative)
                !_.isNumber(values.relative) ? values.relative = Number(values.relative.replace(/[^\d.-]/g, '')) : null;
            else
                values.relative = 0;

            if (!values.fee)
                values.fee = 0;

            if (values.amount_pagadora)
                !_.isNumber(values.amount_pagadora) ? values.amount_pagadora = Number(values.amount_pagadora.replace(/[^\d.-]/g, '')) : null;
            else
                values.amount_pagadora = 0;

            if (values.amount_missing)
                !_.isNumber(values.amount_missing) ? values.amount_missing = Number(values.amount_missing.replace(/[^\d.-]/g, '')) : null;
            else
                values.amount_missing = 0;

            
            // Si es pago directo del hotel, asignamos al campo pagadora el salario mínimo para que funcione bien en la generación de nómina
            if (values.payment_type === 'hotel')
                values.amount_pagadora = values.salary;

            
            if (!this.props.params.employeeId) {
                // CREA

                // Model
                let data = {...values};
                data.active = true;
                data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
                
                if (values.hotel && values.hotel.key) {
                    data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
                }

                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Employee', data).then(resp => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el empleado exitosamente');

                    this.props.form.resetFields();
                    this.props.form.setFieldsValue({phone: '', salary: '$0'})
                    this.setState({imageUrl: ''})

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                if (values.hotel && values.hotel.key) {
                    _.extend(this.state.employee, {
                        ...values, 
                        hotel: {...values.hotel, name: values.hotel.label} 
                    });
                } else {
                    _.extend(this.state.employee, { ...values });
                }

                this.props.dispatch({type: 'employee/update', payload: this.state.employee})
                this.context.router.goBack();
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        <Link to="/employees"><i className="fa fa-arrow-circle-left"></i></Link>
                        Empleado
                    </h1>
                </section>

                <section className="content">
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Información personal
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    {this.props.params.employeeId
                                        ? <div className="col-md-12">
                                            Status: <FormItem hasFeedback>
                                                {this.props.form.getFieldDecorator('active')(
                                                    <Switch checkedChildren={<Icon type="check" />} unCheckedChildren={<Icon type="cross" />} checked={this.props.form.getFieldValue('active')} />
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-2">
                                        <label>Foto <small>(opcional)</small></label>
                                        <Upload
                                            className="avatar-uploader"
                                            name="file"
                                            accept="image/*"
                                            showUploadList={true}
                                            action={config.externalUrl + "includes/upload.php"}
                                            beforeUpload={this.beforeUpload.bind(this)}
                                            onChange={this.handlePictureChange.bind(this)}
                                            headers={{
                                                "X-Parse-Application-Id": config.appId
                                            }}
                                            data={{
                                                type: 'user',
                                                custom_name: this.state.file.uid + '.jpg'
                                            }}
                                        >
                                            {this.state.imageUrl ?
                                                <img src={this.state.imageUrl} alt="" className="avatar" /> :
                                                this.state.loading ? 
                                                    <IconAwesome name="refresh" spin className="spin-uploader" />
                                                    : <Icon type="plus" className="avatar-uploader-trigger" />
                                            }
                                        </Upload>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="col-md-4">
                                            <FormItem label="Tipo de Empleado" hasFeedback>
                                                {this.props.form.getFieldDecorator('type', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, elija el tipo de empleado'
                                                    }]
                                                })(
                                                    <Select size='large'>
                                                        <Option value="trie">Empleado TRIE</Option>
                                                        <Option value="hotel">Empleado del Hotel</Option>
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>

                                        {this.props.form.getFieldValue('type') === 'hotel'
                                            ? <div className="col-md-4">
                                                <FormItem label="Hotel al que pertenece" hasFeedback>
                                                    {this.props.form.getFieldDecorator('hotel', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el hotel al que pertence el empleado',
                                                        }, {
                                                            validator: this.checkHotel.bind(this)
                                                        }]
                                                    })(
                                                        <Select 
                                                            size='large'
                                                            mode="combobox"
                                                            onChange={this.handleSelectHotelChange.bind(this)}
                                                            filterOption={false}
                                                            labelInValue={true}
                                                            optionLabelProp='label'
                                                            disabled={this.props.app.user.type === 'gerente' ? true : false}
                                                            >
                                                            {hotel_options}
                                                        </Select>
                                                    )}
                                                </FormItem>
                                            </div>
                                            : ''
                                        }

                                        <div className="col-md-4">
                                            <FormItem label="Puesto" hasFeedback>
                                                {this.props.form.getFieldDecorator('job', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, elija el puesto del empleado'
                                                    }]
                                                })(
                                                    <Select size='large'>
                                                        <Option value="gerente">Gerente</Option>
                                                        <Option value="recepcionista">Recepcionista</Option>
                                                        <Option value="camarista">Camarista</Option>
                                                        <Option value="empleado">Empleado</Option>
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Nombre completo" hasFeedback>
                                                {this.props.form.getFieldDecorator('name', {
                                                    rules: [{
                                                        required: true,
                                                        message: 'Por favor, ingrese el nombre completo'
                                                    }]
                                                })(<Input size='large' />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="RFC" hasFeedback>
                                                {this.props.form.getFieldDecorator('rfc', {
                                                    rules: [{
                                                        required: false,
                                                        message: 'Por favor, ingrese el RFC'
                                                    }]
                                                })(<Input size='large' style={{textTransform: 'uppercase'}} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="CURP" hasFeedback>
                                                {this.props.form.getFieldDecorator('curp', {
                                                    rules: [{
                                                        required: false,
                                                        message: 'Por favor, ingrese el CURP'
                                                    }]
                                                })(<Input size='large' style={{textTransform: 'uppercase'}} />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Correo electrónico" hasFeedback>
                                                {this.props.form.getFieldDecorator('email', {
                                                    rules: [{
                                                        type: 'email',
                                                        required: false,
                                                        message: 'Por favor, ingrese el correo electrónico del empleado'
                                                    }]
                                                })(<Input size='large' />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Teléfono" hasFeedback>
                                                {this.props.form.getFieldDecorator('phone', {
                                                    rules: [{
                                                        required: false,
                                                    }, {
                                                        validator: this.checkPhone.bind(this)
                                                    }]
                                                })(<InputMask mask="(999) 999 9999" className="ant-input ant-input-lg" />)}
                                            </FormItem>
                                        </div>

                                        <div className="col-md-4">
                                            <FormItem label="Fecha de nacimiento" hasFeedback>
                                                {this.props.form.getFieldDecorator('birthday', {
                                                    rules: [{
                                                        required: false,
                                                        message: 'Por favor, ingrese la fecha de nacimiento'
                                                    }]
                                                })(<DatePicker format="DD-MM-YYYY" />)}
                                            </FormItem>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Información laboral
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <FormItem label="No. IMSS" hasFeedback>
                                            {this.props.form.getFieldDecorator('imss', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese el número del IMSS'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Fecha de Alta IMSS" hasFeedback>
                                            {this.props.form.getFieldDecorator('alta_imss', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese la fecha de alta del IMSS'
                                                }]
                                            })(<DatePicker format="DD-MM-YYYY" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Fecha Alta Empleado" hasFeedback>
                                            {this.props.form.getFieldDecorator('alta_employee', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese la fecha de alta del empleado'
                                                }]
                                            })(<DatePicker format="DD-MM-YYYY" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Sueldo diario" hasFeedback>
                                            {this.props.form.getFieldDecorator('salary', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese un monto correcto'
                                                }, {
                                                    validator: this.checkSalary.bind(this)
                                                }]
                                            })(
                                                <NumberFormat 
                                                    thousandSeparator={true} 
                                                    prefix={'$'} 
                                                    className="ant-input ant-input-lg" />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Periodicidad del Pago" hasFeedback>
                                            {this.props.form.getFieldDecorator('periodicity', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija la periodicidad del pago'
                                                }]
                                            })(
                                                <Select size='large'>
                                                    <Option value="semanal">Semanal</Option>
                                                    <Option value="catorcenal">Catorcenal</Option>
                                                    <Option value="quincenal">Quincenal</Option>
                                                    <Option value="mensual">Mensual</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Tipo de nómina" hasFeedback>
                                            {this.props.form.getFieldDecorator('payment_type', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el tipo de nómina'
                                                }]
                                            })(
                                                <Select size='large'>
                                                    <Option value="hotel">Pago Directo Hotel</Option>
                                                    <Option value="pagadora">Pago Workania</Option>
                                                    <Option value="trie">Pago Directo TRIE</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Infonavit">
                                            {this.props.form.getFieldDecorator('total_infonavit', {
                                                initialValue: this.props.params.employeeId ? '$' + parseFloat(this.state.employee.total_infonavit).toFixed(2) : '$0',
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese un monto correcto'
                                                }]
                                            })(
                                                <NumberFormat 
                                                    thousandSeparator={true} 
                                                    prefix={'$'} 
                                                    className="ant-input ant-input-lg" />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="P. Dominical">
                                            {this.props.form.getFieldDecorator('bonus_sunday', {
                                                initialValue: this.props.params.employeeId ? '$' + parseFloat(this.state.employee.bonus_sunday).toFixed(2) : '$0',
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese un monto correcto'
                                                }]
                                            })(
                                                <NumberFormat 
                                                    thousandSeparator={true} 
                                                    prefix={'$'} 
                                                    className="ant-input ant-input-lg" />
                                            )}
                                        </FormItem>
                                    </div>

                                    {this.props.form.getFieldValue('payment_type') && this.props.form.getFieldValue('payment_type') !== 'hotel'
                                        ? <div>
                                            <div className="col-xs-12" style={{padding: 0}}>
                                                <div className="col-md-3">
                                                    <FormItem label="Relativos" hasFeedback>
                                                        {this.props.form.getFieldDecorator('relative', {
                                                            initialValue: this.props.params.employeeId ? '$' + parseFloat(this.state.employee.relative).toFixed(2) : '$0',
                                                            rules: [{
                                                                required: false,
                                                                message: 'Por favor, ingrese un monto correcto'
                                                            }]
                                                        })(
                                                            <NumberFormat 
                                                                thousandSeparator={true} 
                                                                prefix={'$'} 
                                                                className="ant-input ant-input-lg" />
                                                        )}
                                                    </FormItem>
                                                </div>

                                                <div className="col-md-3">
                                                    <FormItem label="Honorarios" hasFeedback>
                                                        {this.props.form.getFieldDecorator('fee', {
                                                            initialValue: this.props.params.employeeId ? this.state.employee.fee : 0,
                                                            rules: [{
                                                                required: false,
                                                                message: 'Por favor, ingrese un monto correcto'
                                                            }]
                                                        })(
                                                            <InputNumber
                                                                min={0}
                                                                max={100}
                                                                formatter={value => `${value}%`}
                                                                parser={value => value.replace('%', '')}
                                                                className="ant-input ant-input-lg"
                                                            />
                                                        )}
                                                    </FormItem>
                                                </div>
                                            </div>

                                            <div className="col-xs-12" style={{padding: 0}}>
                                                <div className="col-md-2 col-xs-4">
                                                    <FormItem label={this.props.form.getFieldValue('payment_type') === 'pagadora' ? '% Pagadora' : '% Alta'} hasFeedback>
                                                        {this.props.form.getFieldDecorator('percent_pagadora', {
                                                            initialValue: !this.props.params.employeeId ? 100 : this.state.employee.percent_pagadora,
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese un monto correcto',
                                                            }]
                                                        })(
                                                            <InputNumber
                                                                min={0}
                                                                max={100}
                                                                formatter={value => `${value}%`}
                                                                parser={value => value.replace('%', '')}
                                                                onChange={this.handlePercentPagadora.bind(this)}
                                                                className="ant-input ant-input-lg"
                                                            />
                                                        )}
                                                    </FormItem>
                                                </div>

                                                <div className="col-md-4 col-xs-8">
                                                    <FormItem label={this.props.form.getFieldValue('payment_type') === 'pagadora' ? 'Sueldo Pagadora' : 'Sueldo Alta'} hasFeedback>
                                                        {this.props.form.getFieldDecorator('amount_pagadora', {
                                                            initialValue: this.props.form.getFieldValue('salary') && !this.props.params.employeeId ? this.props.form.getFieldValue('salary') : '$' + parseFloat(this.state.employee.amount_pagadora).toFixed(2),
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese un monto correcto'
                                                            }, {
                                                                validator: this.checkAmountPagadora.bind(this)
                                                            }]
                                                        })(
                                                            <NumberFormat 
                                                                thousandSeparator={true} 
                                                                prefix={'$'} 
                                                                className="ant-input ant-input-lg" />
                                                        )}
                                                    </FormItem>
                                                </div>

                                                <div className="col-md-2 col-xs-4">
                                                    <FormItem label={this.props.form.getFieldValue('payment_type') === 'pagadora' ? '% Restante' : '% Depósito'} hasFeedback>
                                                        {this.props.form.getFieldDecorator('percent_missing', {
                                                            initialValue: !this.props.params.employeeId ? 0 : this.state.employee.percent_missing,
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese un monto correcto'
                                                            }]
                                                        })(
                                                            <InputNumber
                                                                min={0}
                                                                max={100}
                                                                formatter={value => `${value}%`}
                                                                parser={value => value.replace('%', '')}
                                                                onChange={this.handlePercentMissing.bind(this)}
                                                                className="ant-input ant-input-lg"
                                                            />
                                                        )}
                                                    </FormItem>
                                                </div>

                                                <div className="col-md-4 col-xs-8">
                                                    <FormItem label={this.props.form.getFieldValue('payment_type') === 'pagadora' ? 'Sueldo Restante' : 'Sueldo Depósito'} hasFeedback>
                                                        {this.props.form.getFieldDecorator('amount_missing', {
                                                            initialValue: !this.props.params.employeeId ? '$0' : '$' + parseFloat(this.state.employee.amount_missing).toFixed(2),
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, ingrese un monto correcto'
                                                            }, {
                                                                validator: this.checkAmountMissing.bind(this)
                                                            }]
                                                        })(
                                                            <NumberFormat 
                                                                thousandSeparator={true} 
                                                                prefix={'$'} 
                                                                className="ant-input ant-input-lg" />
                                                        )}
                                                    </FormItem>
                                                </div>
                                            </div>
                                        </div>
                                        : ''
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Domicilio
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-2">
                                        <FormItem label="Calle" hasFeedback>
                                            {this.props.form.getFieldDecorator('street', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese la calle de la dirección'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Número Exterior" hasFeedback>
                                            {this.props.form.getFieldDecorator('exterior_number', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese el número de la dirección'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Colonia" hasFeedback>
                                            {this.props.form.getFieldDecorator('colony')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Número Interior" hasFeedback>
                                            {this.props.form.getFieldDecorator('interior_number')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Localidad" hasFeedback>
                                            {this.props.form.getFieldDecorator('locality', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese la localidad'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Municipio" hasFeedback>
                                            {this.props.form.getFieldDecorator('city')(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="País" hasFeedback>
                                            {this.props.form.getFieldDecorator('country', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, elija el país'
                                                }]
                                            })(
                                                <Select 
                                                    showSearch 
                                                    size="large" 
                                                    onChange={this.handleCountry.bind(this)}
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                                                    <Option value="México">México</Option>
                                                    <Option value="USA">Estados Unidos</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="Estado" hasFeedback>
                                            {this.props.form.getFieldDecorator('state', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, elija el estado'
                                                }]
                                            })(
                                                <Select 
                                                    showSearch 
                                                    size="large"
                                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} >
                                                    {this.state.states_options}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-2">
                                        <FormItem label="CP" hasFeedback>
                                            {this.props.form.getFieldDecorator('zip', {
                                                rules: [{
                                                    required: false,
                                                    message: 'Por favor, ingrese el código postal de la dirección'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>
                                </div>

                                <div className="row text-center">
                                    <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                        Guardar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </section>
            </div>
        )
    }
}

EmployeeNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({user, app}) => ({user, app}))(Form.create()(EmployeeNew))


// WEBPACK FOOTER //
// ./src/components/employees/employeeNew.js